import React from 'react';
import { useTrack } from '../analytics/TrackingContext';

const ResetButton = () => {
  const { trackEvent, flush } = useTrack();

  const handleReset = async () => {
    // Resetear todos los inputs de tipo número
    const inputs = document.querySelectorAll('input[type="number"]');
    
    inputs.forEach(input => {
      // Limpiar el valor
      input.value = '';
      
      // Forzar actualización del estado React
      const changeEvent = new Event('change', { bubbles: true });
      input.dispatchEvent(changeEvent);
      
      // Forzar actualización del input
      const inputEvent = new Event('input', { bubbles: true });
      input.dispatchEvent(inputEvent);
    });

    // Recargar la página para asegurar un reseteo completo
    trackEvent('calculator_reset', {
      screen: 'calculator',
      properties: { reason: 'manual' },
    });
    await flush();
    window.location.reload();
  };

  return (
    <div style={{ textAlign: 'center', margin: '1rem' }}>
      <button 
        className="reset-button" 
        onClick={handleReset}
      >
        Limpiar Datos y Comenzar de Nuevo
      </button>
    </div>
  );
};

export default ResetButton;
